class Salutation {
  // 先生:1, 女士:2, 小姐:3, 博士:4
  static MR = 1;
  static MS = 2;
  static MISS = 3;
  static DR = 4;
  static getSalutation(salutation) {
    switch (salutation) {
      case Salutation.MR:
        return 'Mr.';
      case Salutation.MS:
        return 'Ms.';
      case Salutation.MISS:
        return 'Miss';
      case Salutation.DR:
        return 'Dr.';
      default:
        return '';
    }
  }
}

export { Salutation };